import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {



  // selectLang= localStorage.getItem('lang')
  
  
  
  selectLang= new BehaviorSubject('en-US')

  constructor() {}

  public getTranslated(obj: any, fieldName: string): string {
    if (!obj) return '';
    const activeLang = localStorage.getItem('lang') || 'en-US';
    const list = obj.translates || obj.translated || obj.owner?.translates || obj.owner?.translated;
    if (Array.isArray(list) && list.length > 0) {
      const match = list.find((t: any) => t.lang === activeLang);
      if (match && match[fieldName]) {
        return match[fieldName];
      }
    }
    return obj[fieldName] || obj.company_name || '';
  }
}
